@if (isGlobalAdministrator$ | async) {
  @if (context$ | async; as context) {
    @if (context.cropField; as cropFieldWithStatus) {
      <specific-form-header-section
        [title]="'TGA.Advice.Evaluation.Title' | translate"
        [cropYear]="context.cropYear"
        [cropField]="cropFieldWithStatus.cropField"
      />

      <div class="evaluation-pills">
        <button
          type="button"
          class="evaluation-pill"
          [class.evaluation-pill--selected]="selectedView() === evaluationView.GeneralInformation"
          [attr.aria-pressed]="selectedView() === evaluationView.GeneralInformation"
          (click)="selectView(evaluationView.GeneralInformation)"
        >
          {{ 'TGA.Advice.Evaluation.Reports.GeneralInformation' | translate }}
        </button>
        <button
          type="button"
          class="evaluation-pill"
          [class.evaluation-pill--selected]="selectedView() === evaluationView.Phytophthora"
          [attr.aria-pressed]="selectedView() === evaluationView.Phytophthora"
          (click)="selectView(evaluationView.Phytophthora)"
        >
          {{ 'TGA.Advice.Evaluation.Reports.Phytophthora' | translate }}
        </button>
        <button
          type="button"
          class="evaluation-pill"
          [class.evaluation-pill--selected]="selectedView() === evaluationView.Fertilizer"
          [attr.aria-pressed]="selectedView() === evaluationView.Fertilizer"
          (click)="selectView(evaluationView.Fertilizer)"
        >
          {{ 'TGA.Advice.Evaluation.Reports.Fertilizer' | translate }}
        </button>
        <button
          type="button"
          class="evaluation-pill"
          [class.evaluation-pill--selected]="selectedView() === evaluationView.Veldwaarnemingen"
          [attr.aria-pressed]="selectedView() === evaluationView.Veldwaarnemingen"
          (click)="selectView(evaluationView.Veldwaarnemingen)"
        >
          {{ 'TGA.Advice.Evaluation.Reports.Veldwaarnemingen' | translate }}
        </button>
        <button
          type="button"
          class="evaluation-pill"
          [class.evaluation-pill--selected]="selectedView() === evaluationView.Gewasgroei"
          [attr.aria-pressed]="selectedView() === evaluationView.Gewasgroei"
          (click)="selectView(evaluationView.Gewasgroei)"
        >
          {{ 'TGA.Advice.Evaluation.Reports.Gewasgroei' | translate }}
        </button>
      </div>

      <div class="evaluation-report">
        @switch (selectedView()) {
          @case (evaluationView.GeneralInformation) {
            <app-tga-general-information-evaluation />
          }
          @case (evaluationView.Phytophthora) {
            <app-tga-phytophthora-evaluation />
          }
          @case (evaluationView.Fertilizer) {
            <app-tga-fertilizer-evaluation />
          }
          @case (evaluationView.Veldwaarnemingen) {
            <app-tga-veldwaarnemingen-evaluation />
          }
          @case (evaluationView.Gewasgroei) {
            <app-tga-biomass-evaluation [cropYear]="context.cropYear" />
          }
        }
      </div>
    }
  }
}
